import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import AppRoutes from '../app-routes';
import { UserSessionService } from '../services/user-session.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  constructor(
    private readonly userSessionService: UserSessionService,
    private readonly router: Router,
  ) {
  }

  ngOnInit(): void {
    this.userSessionService.isLoggedInChanged.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.router.navigate([AppRoutes.Changeover]);
      }
    });
  }
}
